import { Text } from "@consta/uikit/Text"
import { Card } from '@consta/uikit/Card';
import { IconTable2 } from '@consta/icons/IconTable2'
import { IconFolderOpen } from "@consta/icons/IconFolderOpen";
import { IconLineAndBarChart } from "@consta/icons/IconLineAndBarChart";
import { IconWellOpen } from "@consta/icons/IconWellOpen";
import { IconOperators } from "@consta/icons/IconOperators";
import { IconPaste } from "@consta/icons/IconPaste";
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import classes from './MainPageContent.module.scss'

const MainPageContent = () => {
    const navigate = useNavigate();
    const [userAccessLevel, setUserAccessLevel] = useState<number | null>(null);

    useEffect(() => {
        // Проверяем уровень доступа при загрузке компонента
        const storedUserInfo = localStorage.getItem('userInfo');
        if (storedUserInfo) {
            try {
                const parsedUserInfo = JSON.parse(storedUserInfo);
                setUserAccessLevel(parsedUserInfo.role?.access_level || 0);
            } catch (error) {
                console.error('Ошибка парсинга userInfo из localStorage:', error);
                setUserAccessLevel(0);
            }
        } else {
            setUserAccessLevel(0);
        }
    }, []);

    const handleCardClick = (path: string) => {
        navigate(path);
    };

    // Если уровень доступа еще не загружен, показываем заглушку
    if (userAccessLevel === null) {
        return (
            <div className={classes.main}>
                <div className={classes.text}>
                    <Text>Загрузка...</Text>
                </div>
            </div>
        );
    }

    return (
        <div className={classes.main}>
            <div className={classes.text}>
                <Text style={{color: '#0078d2'}} size='3xl' weight='bold'>Веб-платформа "GEOINDICATOR"</Text>
                <Text size='l' view='secondary'>Комплексные прецизионные геохимические исследования пластового флюида</Text>
                <Text size='l' view='secondary'>Комплексные исследования пластовых флюидов для анализа и управления разработкой месторождений</Text>
            </div>
            <div className={classes.card}>
                {/* Проекты - всегда доступны */}
                <Card 
                    verticalSpace="2xl" 
                    horizontalSpace="2xl" 
                    className={classes.cardOption}
                    onClick={() => handleCardClick('/project')}
                    style={{ cursor: 'pointer' }}
                >
                    {/*@ts-ignore */}
                    <IconFolderOpen style={{color: '#0078d2'}}/>
                    <Text>Проекты</Text>
                </Card>

                {/* Отчеты - только для access_level = 3 */}
                {userAccessLevel === 3 && (
                    <Card 
                        verticalSpace="2xl" 
                        horizontalSpace="2xl"  
                        className={classes.cardOption}
                        onClick={() => handleCardClick('/report')}
                        style={{ cursor: 'pointer' }}
                    >
                        {/*@ts-ignore */}
                        <IconPaste style={{color: '#0078d2'}}/>
                        <Text>Отчеты</Text>
                    </Card>
                )}

                {/* Скважины - только для access_level = 3 */}
                {userAccessLevel === 3 && (
                    <Card 
                        verticalSpace="2xl" 
                        horizontalSpace="2xl" 
                        className={classes.cardOption}
                        onClick={() => handleCardClick('/wells')}
                        style={{ cursor: 'pointer' }}
                    >
                        {/*@ts-ignore */}
                        <IconWellOpen style={{color: '#0078d2'}}/>
                        <Text>Скважины</Text>
                    </Card>
                )}

                {/* Статистика - только для access_level = 3 */}
                {userAccessLevel === 3 && (
                    <Card 
                        verticalSpace="2xl" 
                        horizontalSpace="2xl" 
                        className={classes.cardOption}
                        onClick={() => handleCardClick('/statistics')}
                        style={{ cursor: 'pointer' }}
                    >
                        {/*@ts-ignore */}
                        <IconOperators style={{color: '#0078d2'}}/>
                        <Text>Статистика</Text>
                    </Card>
                )}
            </div>
            <Text as='span' className={classes.footer} view='secondary' size='l'>
                <Text>«GEOINDICATOR» — современная веб-платформа для интеграции, анализа и </Text>
                <Text>визуализации геохимических данных пластовых флюидов. Решение разработано</Text>
                <Text>специалистами ООО «Геоиндикатор» для повышения точности и эффективности</Text>
                <Text>исследований нефтегазовых месторождений.</Text>
            </Text>
        </div>
    )
}

export default MainPageContent